var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5a.75.75 0 0 0-1.5 0h1.5ZM18 6v.75h.75V6H18Zm-2.283-3.674-.106-.742.106.742ZM4.92 3.87l-.106-.743.106.743ZM8 11.25a.75.75 0 0 0 0 1.5v-1.5Zm8 1.5a.75.75 0 0 0 0-1.5v1.5Zm-8 2a.75.75 0 0 0 0 1.5v-1.5Zm5.5 1.5a.75.75 0 0 0 0-1.5v1.5ZM19.25 9v10h1.5V9h-1.5ZM17 21.25H7v1.5h10v-1.5ZM4.75 19V6h-1.5v13h1.5Zm0-13V5h-1.5v1h1.5ZM4 6.75h13v-1.5H4v1.5Zm3 14.5A2.25 2.25 0 0 1 4.75 19h-1.5A3.75 3.75 0 0 0 7 22.75v-1.5ZM19.25 19A2.25 2.25 0 0 1 17 21.25v1.5A3.75 3.75 0 0 0 20.75 19h-1.5Zm1.5-10A3.75 3.75 0 0 0 17 5.25v1.5A2.25 2.25 0 0 1 19.25 9h1.5ZM5.071 6.75H18v-1.5H5.071v1.5ZM18.75 6V4.306h-1.5V6h1.5Zm-3.139-4.416L4.814 3.126l.212 1.485L15.823 3.07l-.212-1.485ZM4.814 3.126A1.821 1.821 0 0 0 3.25 4.93h1.5a.32.32 0 0 1 .276-.318l-.212-1.485Zm13.936 1.18a2.75 2.75 0 0 0-3.139-2.722l.212 1.485a1.25 1.25 0 0 1 1.427 1.237h1.5ZM5.071 5.25a.321.321 0 0 1-.321-.321h-1.5A1.82 1.82 0 0 0 5.071 6.75v-1.5ZM8 12.75h8v-1.5H8v1.5Zm0 3.5h5.5v-1.5H8v1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.662b7c98e025c102e2c8ac08945eb084.svg";
export { ForwardRef as ReactComponent };